<template>
  <div class="w-full">
    <v-btn
      class="w-full"
      :disabled="disabled"
      :loading="loading"
      @click="show = true"
    >
      {{ $t('settings.crm.deactivate-sync-dialog.title') }}
    </v-btn>
    <v-dialog
      v-model="show"
      width="700"
    >
      <v-card>
        <v-card-title
          class="pa-0"
        >
          <v-toolbar
            color="warning"
            dark
            flat
          >
            <v-icon
              large
              class="mr-4"
            >
              mdi-alert
            </v-icon>
            <v-toolbar-title>{{ $t('settings.crm.deactivate-sync-dialog.title') }}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="show = false"
              >
                <v-icon large>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="mt-4 text-body-1">
          <v-row>
            <v-col>
              <p>
                {{ $t('settings.crm.deactivate-sync-dialog.body-texts.0', { readablePlatformName }) }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="show = false"
          >
            {{ $t('labels.cancel') }}
          </v-btn>

          <v-btn
            color="warning"
            @click="deactivate"
          >
            Stoppen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import brandingMixin from '@/mixins/branding'

export default {
  mixins: [brandingMixin],
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    deactivate () {
      this.$emit('deactivate')
      this.show = false
    }
  }
}
</script>
